import apiClient from './axios';
import type { ApiEnvelope } from '../types';

export const pushApi = {
  /** Fetches the VAPID public key from the backend. Required as input
   *  to `pushManager.subscribe`. */
  async vapidPublicKey(): Promise<string> {
    const res = await apiClient.get<ApiEnvelope<{ publicKey: string }>>(
      '/vendor/push/vapid-public-key',
    );
    return res.data.data.publicKey;
  },

  async subscribe(payload: {
    endpoint: string;
    p256dh: string;
    auth: string;
  }): Promise<void> {
    await apiClient.post('/vendor/push/subscribe', payload);
  },

  async unsubscribe(endpoint: string): Promise<void> {
    await apiClient.delete('/vendor/push/subscribe', { data: { endpoint } });
  },
};
